import { useContext } from "react";
import { EditableContext } from "../../common/EditableContextProvider";
import { Modal, Table } from "antd";
const { Column } = Table;

export const ModalPagos = () => {
    const { casos, pagos } = useContext(EditableContext);
    
    return (
        <Modal
            width={1200}
            open={pagos.visibleModalPagos}
            onCancel={pagos.closeModalPagos}
            destroyOnClose={true}
            footer={null}
        >
            <div className="mb-2">
                <h5>Pagos</h5>
                {
                    (casos.editItem.id > 0) ? (
                        <div className="my-2">
                            <Table
                                size="small"
                                dataSource={casos.editItem.pagos}
                                rowKey="id"
                                scroll={{ y: 400, }}
                                pagination={{ position:[] }}
                                bordered
                            >
                                <Column title="ID" dataIndex="id" key="id" align="center" className="fw-bold"
                                    width={100}
                                    render={(value) => sprintf('%04d', value)}
                                />
                                <Column title="Código" dataIndex="codigo" key="codigo" align="center"
                                    width={100}
                                />
                                <Column title="Fecha" dataIndex="fecha" key="fecha" align="center"
                                    width={100}
                                />
                                <Column title="Monto en Bs." dataIndex="monto" key="monto"
                                    width={100}
                                />
                                <Column title="Descripción" dataIndex="descripcion" key="descripcion"
                                    width={250}
                                    render={(value, row) => (
                                        <span className="fw-bold">
                                            {value}
                                        </span>
                                    )}
                                />
                                <Column title="Estado" dataIndex="estado" key="estado"
                                    width={200}
                                    render={(value, row) => (
                                        <>{value}</>
                                    )}
                                />
                            </Table>
                        </div>
                    ) : (<>Guarda el registro para agregar pagos.</>)
                }
            </div>
        </Modal>
    );
}